import { put } from 'redux-saga/effects';
import { whiteboardOpened } from 'features/layout/features/content/actions';
import { contentLibraryFileOpenRequested } from 'features/content-library/actions';

export function* openWhiteboardSaga(action: ReturnType<typeof whiteboardOpened>) {
  if (action.payload) {
    yield put(contentLibraryFileOpenRequested({ id: action.payload }));
  }
}
